module.exports = __webpack_public_path__ + "img/add-user.94650506.svg";